// src/utils/location.js
// Agar user ne browser mein location permission allow ki hai, to
// coordinates lekar free reverse-geocoding API (OpenStreetMap Nominatim)
// se address nikalte hain. Permission deny/unavailable ho to null return
// karta hai — kabhi bhi form ko block nahi karta.

export const getAddressIfPermitted = () => {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null); // browser geolocation support hi nahi karta
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;

          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
            { headers: { 'Accept-Language': 'en' } }
          );
          const data = await res.json();
          const addr = data.address || {};

          resolve({
            street:  [addr.road, addr.house_number].filter(Boolean).join(', ') || undefined,
            city:    addr.city || addr.town || addr.village || undefined,
            state:   addr.state || undefined,
            country: addr.country || undefined,
            zipCode: addr.postcode || undefined,
            latitude,
            longitude,
          });
        } catch {
          resolve(null); // reverse geocode fail hui to bhi block mat karo
        }
      },
      () => resolve(null),               // 👈 permission deny/timeout — silently skip
      { timeout: 5000, maximumAge: 300000 }
    );
  });
};